// removed by extract-text-webpack-plugin
module.exports = {"dataCard":"data-card-module__dataCard___3tCAQ","dataCardExpandContainer":"data-card-module__dataCardExpandContainer___1R2eP","dataCardExpandContainerButton":"data-card-module__dataCardExpandContainerButton___2XlLo","dataCardHeader":"data-card-module__dataCardHeader___1mNra","line":"data-card-module__line___1llvA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-card/data-card.module.scss
// module id = 638
// module chunks = 0 1